import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LineItem } from './LineItem';
import { LineItemType } from './LineItemType';
import { Money } from './Money';
import { UnexpectedLineItemType } from './error';
/**
 * Order details for a request for real-time STT access
 */
export class RealTimeLineItem extends LineItem {
    constructor() {
        super(...arguments);
        this.type = LineItemType.RealTime;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Per-minute rate for real-time streaming service - e.g. price we charge customer for 1 minute of real-time streaming.
     * Set to a rate configured in the court system rate configuration and should not change during customer's order.
     */
    )
], RealTimeLineItem.prototype, "connectionFee", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Identifies whether this order has access to sealed segments
     */
    )
], RealTimeLineItem.prototype, "perMinuteRate", void 0);
export function assertIsRealTimeLineItem(lineItem, message) {
    if (!isRealTimeLineItem(lineItem)) {
        throw typeof message === 'object'
            ? message
            : new UnexpectedLineItemType(message !== null && message !== void 0 ? message : `Expected ${LineItemType.RealTime} line item, but received ${lineItem.type} line item`);
    }
}
export function isRealTimeLineItem(lineItem) {
    return lineItem.type === LineItemType.RealTime;
}
